var _ = require('underscore');

module.exports = function unescapeHTML (str) {
  return _.unescape(str);
};



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/util/unescape-html.js
// module id = 620
// module chunks = 0 2